export const FIELD_NAMES = {
  DATE: 'date',
  TIME: 'time',
  STEPS: 'steps',
} as const;
